import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import appUrl from "../../../config/appUrl";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import * as Yup from "yup";
import classNames from "classnames";
import { Formik, useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import moment from "moment";
import * as XLSX from "xlsx";
import { FilterMatchMode } from "primereact/api";
const Revenue_Report = () => {
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteValue, setSitevalue] = useState(null);
  const [siteId, setSiteId] = useState("");
  const [years, setYears] = useState([]);
  const [year, setYear] = useState("");

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [initialized, setInitialized] = useState(false);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  console.log("siteValue", siteValue);
  const validationSchema = Yup.object().shape({
    // name: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      year: new Date().getFullYear().toString(),
      site: "",
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  // const site = storedLoginRes?.site;
  const site = storedLoginRes?.site?._id;
  useEffect(() => {
    formik.setFieldValue("site", site);
    setSitevalue(site);
    setSiteId(site);
    setInitialized(true);
  }, [site]);


  const getRevenueStates = async () => {
    try {
      setLoading(true);
      const apiUrl = `${appUrl.BASE_URL}parkingHistory/RevenueReport?site=${formik.values.site}&year=${parseInt(formik.values.year)}`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        // If the response is not OK, throw an error
        const errorData = await response.json();
        throw new Error(errorData.msg || "Failed to fetch data");
      }

      const data = await response.json();
      console.log("data: ", data);

      // Ensure `data` is an array
      if (Array.isArray(data)) {
        setStates(data);
      } else {
        setStates([]); // Set an empty array if data is not an array
      }
    } catch (error) {
      console.error(error);
      setStates([]); // Reset states to an empty array in case of an error
    } finally {
      setLoading(false); // Ensure loading is stopped in both success and error cases
    }
  };


  useEffect(() => {
    if (formik.values.site !== "" || formik.values.year !== "") {
      if (initialized) {
        getRevenueStates();
      }
    }
  }, [formik.values.site, formik.values.year, initialized]);

  useEffect(() => {
    getSiteList();
  }, [formik.values.site]);

  useEffect(() => {
    const foundSite = siteList?.find((item) => item?._id === site);
    setSitevalue(foundSite);
  }, [site, siteList]);

  useEffect(() => {
    // Generate an array of years from 2000 to the current year
    const currentYear = new Date().getFullYear();
    const yearsArray = Array.from({ length: currentYear - 1999 }, (_, i) => ({
      value: (2000 + i).toString(),
      label: (2000 + i).toString(),
    }));

    // Sort the array in descending order
    yearsArray.sort((a, b) => parseInt(b.value) - parseInt(a.value));

    // Set the sorted array to the state
    setYears(yearsArray);
    formik.setFieldValue("year", currentYear.toString());
    setInitialized(true);
  }, []);

  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSiteList(data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(states);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Data");
    XLSX.writeFile(workbook, "RevenueData.xlsx");
  };
  return (
    <>
      <div className="p-fluid grid flex justify-content-end">
        <div className="field col-12 md:col-2 ">
          {/* <label style={{ fontWeight: "bold" }}> Site </label> */}
          <Dropdown
            id="site"
            name="site"
            value={formik.values.site}
            onChange={(e) => {
              formik.setFieldValue("site", e.value);
              setSiteId(e.value);
            }}
            filter
            filterBy="site"
            filterMatchMode="contains"
            className={classNames(
              { "p-invalid": isFormFieldValid("site") },
              "TextArea__Round border-round-3xl"
            )}
            options={siteList}
            optionLabel="site"
            optionValue="_id"
            placeholder="Select Site"
            disabled={!!siteValue && siteValue._id === formik.values.site}
            showClear  
          ></Dropdown>
          {getFormErrorMessage("site")}
        </div>

        <div className="field col-12 md:col-2">
          {/* <label style={{ fontWeight: "bold" }}> Year </label> */}
          <Dropdown
            id="value"
            name="label"
            value={formik.values.year}
            onChange={(e) => {
              formik.setFieldValue("year", e.value);
              setYear(e.value);
            }}
            // filter
            filterBy="year"
            filterMatchMode="contains"
            className={classNames(
              { "p-invalid": isFormFieldValid("year") },
              "TextArea__Round border-round-3xl"
            )}
            options={years}
            optionLabel="label"
            optionValue="value"
            placeholder="Select Year"
            // showClear  
          />
          {getFormErrorMessage("year")}
        </div>
        <div className="field col-12 md:col-2">
          {/* <label className="fw-bold"> Export</label> */}
          <Button
            label="Export to excel"
            type="button"
            style={{ borderRadius: "100px" }}
            icon="pi pi-file-excel"
            severity="success"
            onClick={exportExcel}
            data-pr-tooltip="XLS"
          />
        </div>
      </div>
      {states === undefined ? (
        <h1>Loading...</h1>
      ) : (
        <div className="grid">
          <div className="col-12 md:col-12">
            <div className="card">
              <div className="flex justify-content-end mb-4"> </div>
              <DataTable
                scrollable
                scrollHeight="390px"
                emptyMessage="No records found for the selected date"
                rows={10}
                loading={loading}
                value={states}
                paginator
                responsiveLayout="scroll"
              >
                <Column field="site" header="Site Name" />
                <Column field="vehicle_Type" header="Vehicle" />
                <Column field="year" header="Year" />
                <Column field="month" header="Month" />
                <Column field="total_Vehicles" header="Total Vehicles" />
                <Column
                  field="Total_Parking_Fee"
                  header="Parking Fee"
                  body={(rowData) =>
                    new Intl.NumberFormat("en-PK", {
                      style: "currency",
                      currency: "PKR",
                    }).format(rowData.total_Parking_Fee)
                  }
                />
              </DataTable>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Revenue_Report;
